import { notification } from 'antd';
import { all, call, put, take } from 'redux-saga/effects';
import { notifyMessageAction } from 'store/notification/action';
import { NOTIFICATION_TYPE } from 'common/enum';

//Component
import { history } from 'store';
import {
  LOAD_PROJECT_IDENTIFICATION_LIST,
  CREATE_PROJECT_IDENTIFICATION,
  LOAD_PROJECT_IDENTIFICATION_DETAIL,
  UPDATE_PROJECT_IDENTIFICATION,
} from '../type';
import {
  //List
  loadProjectIdentificationListSuccessAction,
  loadProjectIdentificationListErrorAction,

  //Detail
  loadProjectIdentificationDetailSuccessAction,
  loadProjectIdentificationDetailErrorAction,

  //Create
  createProjectIdentificationSuccessAction,
  createProjectIdentificationErrorAction,

  //Update
  updateProjectIdentificationSuccessAction,
  updateProjectIdentificationErrorAction,
} from '../action';

import { projectIdentificationService } from 'services';

function* loadProjectIdentificationList() {
  while (1) {
    const action = yield take(LOAD_PROJECT_IDENTIFICATION_LIST);

    try {
      const listProjectIdentification = yield call(
        projectIdentificationService.loadProjectIdentificationList,
        action.payload,
      );
      yield put(
        loadProjectIdentificationListSuccessAction(listProjectIdentification),
      );
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(loadProjectIdentificationListErrorAction(err));
    }
  }
}

function* loadProjectIdentificationDetail() {
  while (1) {
    const action = yield take(LOAD_PROJECT_IDENTIFICATION_DETAIL);
    try {
      const response = yield call(
        projectIdentificationService.loadProjectIdentificationDetail,
        action.payload,
      );
      yield put(loadProjectIdentificationDetailSuccessAction(response));
    } catch (err) {
      yield put(loadProjectIdentificationDetailErrorAction(err));
    }
  }
}

function* createProjectIdentification() {
  while (1) {
    const action = yield take(CREATE_PROJECT_IDENTIFICATION);
    try {
      const response = yield call(
        projectIdentificationService.createProjectIdentification,
        action.payload,
      );
      const projectIdentificationId = response.id;

      history.push(`/project-identification/${projectIdentificationId}`);

      yield put(createProjectIdentificationSuccessAction(response));

      yield put(
        notifyMessageAction({
          message: {
            id: 'app.project-identification.create-success.message',
          },
        }),
      );
    } catch (err) {
      yield put(
        notifyMessageAction({
          type: NOTIFICATION_TYPE.ERROR,
          message: err.message,
        }),
      );
      yield put(createProjectIdentificationErrorAction(err));
    }
  }
}

function* updateProjectIdentification() {
  while (1) {
    const action = yield take(UPDATE_PROJECT_IDENTIFICATION);
    try {
      const response = yield call(
        projectIdentificationService.updateProjectIdentification,
        action.payload,
      );
      const callback = action.payload.callback;
      if (callback) {
        callback();
      }
      yield put(updateProjectIdentificationSuccessAction(response));

      notification.success({
        message: 'Update success',
      });
    } catch (err) {
      yield put(updateProjectIdentificationErrorAction(err));

      notification.error({
        message: err.message,
      });
    }
  }
}

export default function* rootSaga() {
  yield all([
    loadProjectIdentificationList(),
    createProjectIdentification(),
    loadProjectIdentificationDetail(),
    updateProjectIdentification(),
  ]);
}
